import { Box, Divider } from "@mui/joy";
import { useColors } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { DataGrid } from "../../../../components";
import { columnDef } from "./column-def";
import { ColorSideWidget, ColorForm } from "..";

export default function List() {
    const { useList, useCreate, useUpdate, useDelete } = useColors();
    const listColorsSvc = useList();
    const createColorSvc = useCreate();
    const updateColorSvc = useUpdate();
    const deleteColorSvc = useDelete();

    const [colors, setColors] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingColor, setEditingColor] = useState(null);

    const fetchColors = async () => {
        try {
            const response = await listColorsSvc.mutateAsync();
            setColors(response);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchColors();
    }, []);

    const handleCreate = async (colorData: any) => {
        try {
            await createColorSvc.mutateAsync(colorData);
            await fetchColors();
            setShowForm(false);
        } catch (e) {
            console.error(e);
        }
    };

    const handleUpdate = async (colorData: any) => {
        try {
            await updateColorSvc.mutateAsync(colorData);
            await fetchColors();
            setShowForm(false);
            setEditingColor(null);
        } catch (e) {
            console.error(e);
        }
    };

    const handleDelete = async (id: number) => {
        try {
            await deleteColorSvc.mutateAsync({ id });
            await fetchColors();
        } catch (e) {
            console.error(e);
        }
    };

    const handleEdit = (color: any) => {
        setEditingColor(color);
        setShowForm(true);
    };

    const handleCloseForm = () => {
        setShowForm(false);
        setEditingColor(null);
    };

    return (
        <Box flex={1} height="100%">
            <Box flex={1} display={"flex"} height={"100%"}>
                <DataGrid gridData={colors} autoHeight={true} columnDefs={columnDef()} />
                <Divider orientation="vertical" />
                <ColorSideWidget />
            </Box>

            {showForm && (
                <ColorForm
                    color={editingColor}
                    onSubmit={editingColor ? handleUpdate : handleCreate}
                    onClose={handleCloseForm}
                />
            )}
        </Box>
    );
}
